<template>
  <v-tooltip bottom :open-delay="openDelay">
    <template v-slot:activator="{on, attrs}">
      <div v-bind="attrs" v-on="on">
        <slot />
      </div>
    </template>
    {{message}}
  </v-tooltip>
</template>

<script>
export default {
  name: "Tooltip",
  props: {
    message: {
      type: String,
      required: true
    },
    openDelay: {
      type: [Number, String],
      default: 0
    }
  }
}
</script>

<style scoped>

</style>